export const chatConfig = {
  limits: {
    files: {
      IS_DRIVE_ENABLED: false,
      MAX_FILES_PER_MESSAGE: 5,
      MAX_FILES_PER_SPACEUPLOAD: 10,
      MAX_FILE_SIZE_MB: 20,
      MAX_FILES_PER_CHAT: {
        free: 3,
        premium: 10,
        ultimate: 20,
      },
      MAX_FILES_PER_SPACE: 20
    },
    tokens: {
      MAX_TOKEN_COUNT: 25000,
      MAX_MESSAGE_LENGTH: 60000,
      MAX_SPACE_ATTACHMENTS_TOKENS: 80000
    }
  },

  // UI and interaction
  ui: {
    textarea: {
      defaultHeight: 23, // px
      maxHeight: 250 // px
    },
    autocomplete: {
      triggerCharacter: '/',
      maxSuggestions: 5
    }
  },

  // IDs and temporary data
  identifiers: {
    tempIdPrefix: 'temp-',
    resourceId: {
      format: 'image-{timestamp}-{random}',
      randomLength: 9
    }
  },

  // Timing and delays
  timing: {
    saveDraftDelay: 500, 
  },

  features: {
    testGeneration: true,
    editMessage: true,
  },

  defaults: {
    chatTitle: 'New Chat',
    initialHeader: 'Hello! Ready to learn?'
  },

  suggestions: {
    chatPlaceholder: [
        'Type your thoughts right here',
        'What are we saying today?',
        'Give me your words'
    ],
  },

  cognora: {
    help_link: 'https://cognora.ca/faq'
  }
};